export default "__VITE_ASSET__Dtw_vM50__"